module.exports = __webpack_public_path__ + "img/u310_div.dfa20173.png";